module.exports = __webpack_public_path__ + "img/no_data.bba3d72c.png";